import { render, staticRenderFns } from "./TrainingView.vue?vue&type=template&id=dcd08c5a"
import script from "./TrainingView.vue?vue&type=script&lang=js"
export * from "./TrainingView.vue?vue&type=script&lang=js"
import style0 from "./TrainingView.vue?vue&type=style&index=0&id=dcd08c5a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports